import { Role } from './../../shared/models/role';
import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { Expertise } from '../../shared/models/expertise';
import * as actions from '../../core/actions/expertise.actions';
import * as fromExpertise from '../../core/reducers/expertise.reducer';
import * as fromSession from '../../core/reducers/session.reducer';
import * as jwt_decode from "jwt-decode";
import * as actionSession from "../../core/actions/session.actions";
import { Store } from '@ngrx/store';
import { User } from '../../shared/models/user';
import { Prestation } from '../../shared/models/prestation';
import { UserService } from '../../shared/services/user.service';
import { TypePrestationService } from '../../shared/services/type-prestation.service';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap, delay, concatMap, mapTo, skipWhile, filter } from 'rxjs/operators';
import { NgxPermissionsService } from 'ngx-permissions';

@Component({
  selector: 'app-expertise-prestations',
  templateUrl: './expertise-prestations.component.html',
  styleUrls: ['./expertise-prestations.component.scss']
})
export class ExpertisePrestationsComponent implements OnInit, OnChanges {


	  @Input() prestations: Prestation[] = [];
	  @Input() expertiseId: number;
    @ViewChild("dd", {static: false}) table;

	  datas: any[] = [];
    users: any[] = [];
    typePrestations: any[] = [];
    toUpdate: any[] = [];
    new: Prestation;
    clonedPrestations: { [s: number]: Prestation; } = {};
    lastPrestationId: number = -1;
    user_id: number;

  	constructor(
        private store: Store<any>,
        private userService: UserService,
        private typePrestationService: TypePrestationService,
            private permissionService: NgxPermissionsService

    ) { }

  	ngOnInit() {
  	    this.userService.getAll('name',2,{},0,20).subscribe(t => {
           this.users = (t.body).map(u => { return {label: u.publicIdentity, value: u.id, email:u.email}});

          console.log(this.users);});
        this.typePrestationService.get().subscribe(t => {
          this.typePrestations = (t);
          console.log(this.typePrestations);
          this.store.select(fromSession.selectSession).subscribe(session => {
            if (session)   {
               this.user_id = session.email;


            if (session.roles.filter(r => r === "admin").length === 0) {
              console.log("limit p");
              this.typePrestations = this.typePrestations.filter(t => t.limit_user === 0);
            }
          } else {
            const at = localStorage.getItem("access_token");
                if (at != null) {
                  this.store.dispatch(new actionSession.CreateSession(jwt_decode(at)));
                  console.log("Roles", jwt_decode(at).roles);
                  this.permissionService.loadPermissions(jwt_decode(at).roles);
                }
          }

        });


        });
        this.store.select(fromExpertise.selectExpertiseNewPrestation).subscribe(p => this.new = p);

        this.user_id=2;

   	}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.prestations && changes.prestations.currentValue) {
          changes.prestations.currentValue.forEach(p => {
            if (p.saved) {
               this.table.editingRowKeys[p.id] = false;
            }
          });
        }
    }

    pendingUpdate(id: number): boolean {
        return this.toUpdate.findIndex(p => p.id.toString() === id.toString()) >= 0;
    }

    addPrestation() {
       this.new.expertise = this.expertiseId;
       this.lastPrestationId--;
       this.table.editingRowKeys[this.lastPrestationId] = true;
       const cu = this.users.filter(u => u.email === this.user_id);
      console.log(this.user_id, cu);
       const prest = Object.assign(new Prestation, {
         id: this.lastPrestationId,
         user: cu.length > 0 ? cu[0].value : null,
         type: this.typePrestations[2]
       });

       this.store.dispatch(new actions.AddPrestationAction(this.expertiseId, prest) );
    }


    onRowEditInit(prestation: Prestation) {
       this.clonedPrestations[prestation.id] = Object.assign(new Prestation,{...prestation});

    }
    onDeleteRow(prestation: Prestation) {
       this.store.dispatch(new actions.DeletePrestationAction(this.expertiseId, prestation.id) );
    }

    onRowEditSave(prestation: Prestation) {
        prestation.expertise = this.expertiseId;
        this.store.dispatch(new actions.UpdatePrestationAction(this.expertiseId, prestation) );
        delete this.clonedPrestations[prestation.id];
    }

    onRowEditCancel(prestation: Prestation, index: number) {
        if (this.clonedPrestations[prestation.id]) {
            this.prestations[index] = this.clonedPrestations[prestation.id];
            delete this.clonedPrestations[prestation.id];
        } else {
          this.store.dispatch(new actions.CancelAddPrestationAction(this.expertiseId, prestation.id) );
        }
    }


}
